import { render, staticRenderFns } from "./infoAssignItem.vue?vue&type=template&id=9605fc74&"
import script from "./infoAssignItem.vue?vue&type=script&lang=js&"
export * from "./infoAssignItem.vue?vue&type=script&lang=js&"
import style0 from "./infoAssignItem.vue?vue&type=style&index=0&id=9605fc74&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports